import { n as e, t } from "./apiUrls-H7pc1Czy.js";
import { A as n, C as r, D as i, E as a, M as o, O as s, S as c, T as l, _ as u, a as d, b as f, c as p, d as m, f as h, g, h as _, i as v, j as y, k as b, l as x, m as S, n as C, o as w, p as T, r as E, s as D, t as O, u as k, v as A, w as j, x as M, y as N } from "./useRuleService-BIoMfom3.js";
//#region src/generated/schemas.gen.ts
var P = {
	type: "string",
	minLength: 2,
	maxLength: 2,
	pattern: "[A-Z]{2}",
	description: "ISO 3166-1 alpha-2 country code."
}, F = {
	type: "string",
	enum: ["EU", "NON_EU"],
	description: "A geographic area code that represents a specific list of countries."
}, I = {
	type: "object",
	properties: {
		notifyOnDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Notify sender upon package delivery."
		},
		preferredDate: {
			type: "object",
			properties: { date: {
				type: "string",
				format: "date",
				description: "Recipient specified preferred delivery date."
			} },
			required: ["date"],
			description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated."
		}
	},
	description: "Options regarding delivery timing and notifications.",
	minProperties: 1
}, L = {
	type: "object",
	properties: {
		additionalInsurance: {
			type: "object",
			additionalProperties: !1,
			description: "Provides enhanced insurance coverage beyond the standard amount."
		},
		deliverAtPostalPoint: {
			type: "object",
			additionalProperties: !1,
			description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location."
		},
		freshFood: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit."
		},
		frozen: {
			type: "object",
			additionalProperties: !1,
			description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing."
		},
		hideSender: {
			type: "object",
			additionalProperties: !1,
			description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process."
		},
		insurance: {
			type: "object",
			properties: { amount: {
				type: "object",
				properties: {
					currency: {
						type: "string",
						minLength: 3,
						maxLength: 3,
						description: "ISO 4217 three-letter currency code."
					},
					micros: {
						type: "integer",
						minimum: 0,
						maximum: 9007199254740991,
						description: "The amount of money in integer micros."
					}
				},
				required: ["currency", "micros"],
				description: "The amount to insure."
			} },
			required: ["amount"],
			description: "Provides standard insurance coverage up to the specified monetary amount."
		},
		noTracking: {
			type: "object",
			additionalProperties: !1,
			description: "Disables all tracking and tracing capabilities for the shipment."
		},
		oversizedPackage: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees."
		},
		printReturnLabelAtDropOff: {
			type: "object",
			additionalProperties: !1,
			description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments."
		},
		priorityDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services."
		},
		recipientOnlyDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address."
		},
		requiresAgeVerification: {
			type: "object",
			additionalProperties: !1,
			description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items."
		},
		requiresCashOnDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over."
		},
		requiresReceiptCode: {
			type: "object",
			additionalProperties: !1,
			description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments."
		},
		requiresSignature: {
			type: "object",
			additionalProperties: !1,
			description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility."
		},
		returnContributionFee: {
			type: "object",
			properties: { amount: {
				type: "object",
				properties: {
					currency: {
						type: "string",
						minLength: 3,
						maxLength: 3,
						description: "ISO 4217 three-letter currency code."
					},
					micros: {
						type: "integer",
						minimum: 0,
						maximum: 9007199254740991,
						description: "The amount of money in integer micros."
					}
				},
				required: ["currency", "micros"],
				description: "The amount of the contribution."
			} },
			required: ["amount"],
			description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments."
		},
		returnOnFirstFailedDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period."
		},
		sameDayDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Expedited delivery within the same calendar day that the shipping label is created."
		},
		saturdayDelivery: {
			type: "object",
			additionalProperties: !1,
			description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week."
		},
		scheduledCollection: {
			type: "object",
			additionalProperties: !1,
			description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package."
		},
		customLabelText: {
			type: "object",
			properties: { text: {
				type: "string",
				minLength: 1,
				maxLength: 45,
				description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information."
			} },
			required: ["text"],
			description: "Defines a custom text to be printed on the shipping label."
		}
	},
	description: "The complete set of shipment options.",
	minProperties: 1
}, R = {
	type: "object",
	properties: {
		carrier: {
			type: "string",
			enum: [
				"BPOST",
				"BRT",
				"CHEAP_CARGO",
				"DHL_EUROPLUS",
				"DHL_FOR_YOU",
				"DHL_FREIGHT",
				"DHL_PARCEL_CONNECT",
				"DPD",
				"GLS",
				"INPOST",
				"POSTNL",
				"POSTE_ITALIANE",
				"SPRING",
				"TRUNKRS",
				"UPS_EXPRESS_SAVER",
				"UPS_STANDARD",
				"VIA_TIM"
			],
			description: "The carrier to select to ship a package with."
		},
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		delivery: {
			type: "object",
			properties: {
				options: { $ref: "#/components/schemas/DeliveryOptions" },
				type: {
					type: "string",
					enum: [
						"EARLY_MORNING_DELIVERY",
						"EVENING_DELIVERY",
						"EXPRESS_DELIVERY",
						"MORNING_DELIVERY",
						"PICKUP_EXPRESS_DELIVERY",
						"PICKUP_DELIVERY",
						"SAME_DAY_DELIVERY",
						"STANDARD_DELIVERY"
					],
					description: "The delivery type of the shipment."
				}
			},
			description: "The delivery details of the shipment."
		},
		direction: {
			type: "string",
			enum: ["OUTBOUND", "INBOUND"],
			description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender."
		},
		numberOfLabels: {
			type: "integer",
			minimum: 1,
			maximum: 20
		},
		options: { $ref: "#/components/schemas/ShipmentOptions" },
		packageType: {
			type: "string",
			enum: [
				"DIGITAL_STAMP",
				"ENVELOPE",
				"MAILBOX",
				"PACKAGE",
				"PALLET",
				"SMALL_PACKAGE",
				"UNFRANKED"
			],
			description: "The type of the package."
		}
	},
	required: ["numberOfLabels"],
	description: "An action that applies specific shipping configurations to the order."
}, z = {
	type: "object",
	properties: { setShippingPreferences: {
		type: "object",
		properties: {
			applicationStrategy: {
				type: "string",
				enum: ["PRESERVE", "REPLACE"],
				description: "The strategy to apply the action. 'PRESERVE' keeps shipping preferences if they already exist; 'REPLACE' replaces all existing shipping preferences with the new ones."
			},
			preferences: { $ref: "#/components/schemas/ShippingPreferences" }
		},
		required: ["applicationStrategy", "preferences"]
	} },
	description: "A container for the set of actions to execute. At least one action must be provided, and each action type can only be used once.",
	minProperties: 1
}, B = { anyOf: [{
	type: "object",
	properties: { countryCode: { $ref: "#/components/schemas/CountryCode" } },
	required: ["countryCode"],
	additionalProperties: !1
}, {
	type: "object",
	properties: { geoAreaCode: { $ref: "#/components/schemas/GeoAreaCode" } },
	required: ["geoAreaCode"],
	additionalProperties: !1
}] }, V = {
	type: "string",
	minLength: 4,
	maxLength: 500,
	description: "An expression that evaluates to true or false. The expression can contain the following fields: price, countryCode, productIds, geoAreaCode, salesChannelId, weight, orderedAt, and the following functions: all(), any(), evaluatedAtDayOfWeek() and evaluatedAtTimeOfDay(). See OrderExpressionProperties and OrderExpressionFunctions for more details.",
	example: "price > 100 && price <= 200"
}, H = {
	type: "object",
	properties: {
		on: {
			type: "string",
			enum: ["ORDER_IMPORTED"],
			description: "The event that triggers the rule evaluation."
		},
		rules: {
			type: "array",
			items: {
				type: "object",
				properties: {
					actions: { $ref: "#/components/schemas/OrderActionRuleActions" },
					condition: { $ref: "#/components/schemas/OrderActionRuleCondition" },
					name: {
						type: "string",
						minLength: 2,
						maxLength: 50,
						description: "A human-readable name for the rule."
					},
					status: {
						type: "string",
						enum: ["ACTIVE", "INACTIVE"]
					},
					description: {
						type: "string",
						minLength: 1,
						maxLength: 250,
						description: "A description for what the rule does and its purpose."
					}
				},
				required: [
					"actions",
					"condition",
					"name",
					"status"
				]
			},
			minItems: 1,
			maxItems: 1e3,
			description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied."
		},
		condition: { $ref: "#/components/schemas/OrderRuleGroupCondition" }
	},
	required: [
		"on",
		"rules",
		"condition"
	],
	description: "A prioritized list of rules for an event in a specific region."
}, U = {
	type: "object",
	properties: {
		on: {
			type: "string",
			enum: ["ORDER_IMPORTED"],
			description: "The event that triggers the rule evaluation."
		},
		rules: {
			type: "array",
			items: {
				type: "object",
				properties: {
					actions: { $ref: "#/components/schemas/OrderActionRuleActions" },
					condition: { $ref: "#/components/schemas/OrderActionRuleCondition" },
					name: {
						type: "string",
						minLength: 2,
						maxLength: 50,
						description: "A human-readable name for the rule."
					},
					status: {
						type: "string",
						enum: ["ACTIVE", "INACTIVE"]
					},
					description: {
						type: "string",
						minLength: 1,
						maxLength: 250,
						description: "A description for what the rule does and its purpose."
					},
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of the rule."
					}
				},
				required: [
					"actions",
					"condition",
					"name",
					"status"
				]
			},
			minItems: 1,
			maxItems: 1e3,
			description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied."
		},
		condition: { $ref: "#/components/schemas/OrderRuleGroupCondition" }
	},
	required: [
		"on",
		"rules",
		"condition"
	],
	description: "A prioritized list of rules for an event in a specific region."
}, W = {
	type: "object",
	properties: { results: {
		type: "array",
		items: {
			type: "object",
			properties: {
				id: {
					type: "string",
					format: "uuid",
					description: "The unique identifier of the rule group."
				},
				createdAt: {
					anyOf: [{ type: "string" }, {
						type: "string",
						format: "date-time",
						description: "An ISO 8601 formatted datetime string with timezone offset."
					}],
					description: "The date and time the rule group was created."
				},
				on: {
					type: "string",
					enum: ["ORDER_IMPORTED"],
					description: "The event that triggers the rule evaluation."
				},
				rules: {
					type: "array",
					items: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The unique identifier of the rule."
							},
							actions: { $ref: "#/components/schemas/OrderActionRuleActions" },
							condition: { $ref: "#/components/schemas/OrderActionRuleCondition" },
							name: {
								type: "string",
								minLength: 2,
								maxLength: 50,
								description: "A human-readable name for the rule."
							},
							status: {
								type: "string",
								enum: ["ACTIVE", "INACTIVE"]
							},
							description: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "A description for what the rule does and its purpose."
							}
						},
						required: [
							"id",
							"actions",
							"condition",
							"name",
							"status"
						]
					},
					minItems: 1,
					maxItems: 1e3,
					description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied."
				},
				condition: { $ref: "#/components/schemas/OrderRuleGroupCondition" },
				updatedAt: {
					anyOf: [{ type: "string" }, {
						type: "string",
						format: "date-time",
						description: "An ISO 8601 formatted datetime string with timezone offset."
					}],
					description: "The date and time the rule group was last updated."
				}
			},
			required: [
				"id",
				"createdAt",
				"on",
				"rules",
				"condition"
			],
			description: "A prioritized list of rules for an event in a specific region."
		},
		minItems: 0,
		maxItems: 250,
		description: "The list of order rule groups."
	} },
	required: ["results"]
}, G = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the rule group."
		},
		createdAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the rule group was created."
		},
		on: {
			type: "string",
			enum: ["ORDER_IMPORTED"],
			description: "The event that triggers the rule evaluation."
		},
		rules: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of the rule."
					},
					actions: { $ref: "#/components/schemas/OrderActionRuleActions" },
					condition: { $ref: "#/components/schemas/OrderActionRuleCondition" },
					name: {
						type: "string",
						minLength: 2,
						maxLength: 50,
						description: "A human-readable name for the rule."
					},
					status: {
						type: "string",
						enum: ["ACTIVE", "INACTIVE"]
					},
					description: {
						type: "string",
						minLength: 1,
						maxLength: 250,
						description: "A description for what the rule does and its purpose."
					}
				},
				required: [
					"id",
					"actions",
					"condition",
					"name",
					"status"
				]
			},
			minItems: 1,
			maxItems: 1e3,
			description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied."
		},
		condition: { $ref: "#/components/schemas/OrderRuleGroupCondition" }
	},
	required: [
		"id",
		"createdAt",
		"on",
		"rules",
		"condition"
	],
	description: "A prioritized list of rules for an event in a specific region."
}, K = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The unique identifier of the rule group."
		},
		createdAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the rule group was created."
		},
		on: {
			type: "string",
			enum: ["ORDER_IMPORTED"],
			description: "The event that triggers the rule evaluation."
		},
		rules: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "string",
						format: "uuid",
						description: "The unique identifier of the rule."
					},
					actions: { $ref: "#/components/schemas/OrderActionRuleActions" },
					condition: { $ref: "#/components/schemas/OrderActionRuleCondition" },
					name: {
						type: "string",
						minLength: 2,
						maxLength: 50,
						description: "A human-readable name for the rule."
					},
					status: {
						type: "string",
						enum: ["ACTIVE", "INACTIVE"]
					},
					description: {
						type: "string",
						minLength: 1,
						maxLength: 250,
						description: "A description for what the rule does and its purpose."
					}
				},
				required: [
					"id",
					"actions",
					"condition",
					"name",
					"status"
				]
			},
			minItems: 1,
			maxItems: 1e3,
			description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied."
		},
		condition: { $ref: "#/components/schemas/OrderRuleGroupCondition" },
		updatedAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "The date and time the rule group was last updated."
		}
	},
	required: [
		"id",
		"createdAt",
		"on",
		"rules",
		"condition",
		"updatedAt"
	],
	description: "A prioritized list of rules for an event in a specific region."
}, q = {
	type: "object",
	properties: {
		price: {
			type: "number",
			description: "The total price of the order."
		},
		countryCode: { $ref: "#/components/schemas/CountryCode" },
		productIds: {
			type: "array",
			items: {
				type: "string",
				format: "uuid",
				description: "The unique identifier of the product."
			},
			default: []
		},
		geoAreaCode: { $ref: "#/components/schemas/GeoAreaCode" },
		salesChannelId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the sales channel."
		},
		weight: {
			type: "integer",
			minimum: 0,
			description: "The weight of the order in grams."
		},
		orderedAt: {
			type: "string",
			format: "date-time",
			description: "The date and time the order was placed."
		}
	},
	required: ["price"]
}, J = { anyOf: [
	{
		type: "object",
		properties: { "all(<sequence>, <item>, <condition>)": {
			type: "object",
			properties: {
				params: {
					type: "object",
					properties: {
						sequence: {
							description: "The sequence to be evaluated.",
							example: "productIds"
						},
						item: {
							description: "Refers to the elements in the sequence.",
							example: "id"
						},
						condition: {
							description: "The condition to apply to each element.",
							example: "id == 'bce69c22-df18-4a05-b9ad-38cb36f1ae5c'"
						}
					}
				},
				example: { example: "all(productIds, id, id == 'bce69c22-df18-4a05-b9ad-38cb36f1ae5c' || id == '9bfbdc66-6faf-4784-b62a-da9dd5746042')" }
			},
			required: ["params"],
			description: "Determine whether all elements of a sequence satisfy a condition."
		} },
		required: ["all(<sequence>, <item>, <condition>)"]
	},
	{
		type: "object",
		properties: { "any(<sequence>, <item>, <condition>)": {
			type: "object",
			properties: {
				params: {
					type: "object",
					properties: {
						sequence: {
							description: "The sequence to be evaluated.",
							example: "productIds"
						},
						item: {
							description: "Refers to the elements in the sequence.",
							example: "id"
						},
						condition: {
							description: "The condition to apply to each element.",
							example: "id == 'bce69c22-df18-4a05-b9ad-38cb36f1ae5c'"
						}
					}
				},
				example: { example: "any(productIds, id, id == 'bce69c22-df18-4a05-b9ad-38cb36f1ae5c')" }
			},
			required: ["params"],
			description: "Determine whether any elements of a sequence satisfy a condition."
		} },
		required: ["any(<sequence>, <item>, <condition>)"]
	},
	{
		type: "object",
		properties: { "evaluatedAtDayOfWeek(<daysOfWeek>)": {
			type: "object",
			properties: {
				params: {
					type: "object",
					properties: { daysOfWeek: {
						type: "array",
						items: {
							type: "string",
							enum: [
								"MONDAY",
								"TUESDAY",
								"WEDNESDAY",
								"THURSDAY",
								"FRIDAY",
								"SATURDAY",
								"SUNDAY"
							],
							description: "Day of week."
						},
						minItems: 1,
						maxItems: 7,
						description: "List of week days.",
						example: ["SATURDAY", "SUNDAY"]
					} },
					required: ["daysOfWeek"]
				},
				example: { example: "evaluatedAtDayOfWeek(['SATURDAY','SUNDAY'])" }
			},
			required: ["params"],
			description: "Evaluates to true if the rule evaluation day of week is one of the specified days of the week."
		} },
		required: ["evaluatedAtDayOfWeek(<daysOfWeek>)"]
	},
	{
		type: "object",
		properties: { "evaluatedAtTimeOfDay(<operator>, <time>, <timezone>)": {
			type: "object",
			properties: {
				params: {
					type: "object",
					properties: {
						operator: {
							type: "string",
							enum: [
								"<",
								"<=",
								">",
								">="
							],
							description: "The comparison operator.",
							example: ">="
						},
						time: {
							type: "string",
							pattern: "^([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d$",
							description: "A time string formatted as HH:mm:ss.",
							example: "12:30:00"
						},
						timezone: {
							type: "string",
							description: "The timezone of the specified time.",
							example: "Europe/Amsterdam"
						}
					},
					required: [
						"operator",
						"time",
						"timezone"
					]
				},
				example: { example: "evaluatedAtTimeOfDay('>=', '12:30', 'Europe/Amsterdam')" }
			},
			required: ["params"],
			description: "Compare the rule evaluation time of day with a specified time within a specified timezone."
		} },
		required: ["evaluatedAtTimeOfDay(<operator>, <time>, <timezone>)"]
	}
] }, Y = {
	type: "string",
	format: "uuid",
	description: "The unique identifier of the rule group."
}, X = {
	type: "string",
	minLength: 1,
	maxLength: 50,
	description: "The unique identifier of the shop."
}, Z = {
	EU: "EU",
	NON_EU: "NON_EU"
};
//#endregion
export { P as CountryCodeSchema, I as DeliveryOptionsSchema, Z as GeoAreaCode, F as GeoAreaCodeSchema, W as GetOrderRulesResponseSchema, z as OrderActionRuleActionsSchema, V as OrderActionRuleConditionSchema, J as OrderExpressionFunctionsSchema, q as OrderExpressionPropertiesSchema, B as OrderRuleGroupConditionSchema, H as PostOrderRuleRequestBodySchema, G as PostOrderRuleResponseSchema, U as PutOrderRuleRequestBodySchema, K as PutOrderRuleResponseSchema, Y as RuleGroupIdSchema, L as ShipmentOptionsSchema, R as ShippingPreferencesSchema, X as ShopIdSchema, C as deleteShopsByShopIdOrderRulesByRuleGroupId, E as getShopsByShopIdOrderRules, v as postShopsByShopIdOrderRules, d as putShopsByShopIdOrderRulesByRuleGroupId, t as ruleApiAcceptanceUrl, e as ruleApiUrl, O as useRuleService, w as zCountryCode, D as zDeleteShopsByShopIdOrderRulesByRuleGroupIdData, p as zDeleteShopsByShopIdOrderRulesByRuleGroupIdResponse, x as zDeliveryOptions, k as zGeoAreaCode, m as zGetOrderRulesResponse, h as zGetShopsByShopIdOrderRulesData, T as zGetShopsByShopIdOrderRulesResponse, S as zOrderActionRuleActions, _ as zOrderActionRuleCondition, g as zOrderExpressionFunctions, u as zOrderExpressionProperties, A as zOrderRuleGroupCondition, N as zPostOrderRuleRequestBody, f as zPostOrderRuleResponse, M as zPostShopsByShopIdOrderRulesData, c as zPostShopsByShopIdOrderRulesResponse, r as zPutOrderRuleRequestBody, j as zPutOrderRuleResponse, l as zPutShopsByShopIdOrderRulesByRuleGroupIdData, a as zPutShopsByShopIdOrderRulesByRuleGroupIdResponse, i as zRuleGroupId, s as zRuleGroupId2, b as zShipmentOptions, n as zShippingPreferences, y as zShopId, o as zShopId2 };
